import { LocationTiers } from "./DestinationCrossLinkEnums";

export const getFormatTextLocationKey = (geoType: string) => {
  switch (geoType) {
    case LocationTiers.CITY:
      return "destinationCrossLink.city.label";
    case LocationTiers.REGION:
      return "destinationCrossLink.provinceState.label";
    case LocationTiers.COUNTRY:
      return "destinationCrossLink.country.label";
    default:
      return "destinationCrossLink.city.label";
  }
};
